<p>email-blast-recipient-dialog-def-editor works!</p>
